import React, { Component } from 'react';
import { connect } from 'react-redux'
import { courseActions } from '../actions';

import { attendanceActions } from '../actions/attendanceActions';

import { CardBody, Card, Row, Col,  Modal, Button, ModalBody,
        FormGroup, Label } from 'reactstrap';

import { CenterMessageCard } from 'components/CenterMessageCard';
import { LoadingPage } from 'components/LoadingPage'
import { DayAttendanceCard } from '../components/DayAttendanceCard';
import { Spinner } from 'components/Icons/Spinner';

import Select from "react-select";

import './CourseAttendance.css';

var sdf = require('date-format');

var Const = require ('Const');
var Utils = require ('Utils');
var viewActions = require ('store/view.actions');


class CourseAttendance extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      currentAttendance:[],
      currentStudent: {},
      currentDate: new Date(),
      anioActual: new Date().getFullYear(),
      mesActual: new Date().getMonth(),
      diaActual: new Date().getDate(),
      cargaDirecta: false,
      selectedAttendance: {},
      justified: ''
    };
  }

  setModalOpen ( st ) {
    this.setState({ modalOpen: st }) ;

  }


       componentDidMount() {
         
        this.props.getSchoolCourse(this.props.token, this.props.match.params.id, this.props.currentCalendarID);
        this.props.getHolidays( this.props.token, this.props.currentCalendarID );
        this.props.getCourseAttendance ( this.props.token, this.props.match.params.id,this.props.currentCalendarID) ;
        this.props.getCourseAttendanceStatus ( this.props.token, this.props.match.params.id) ;
        this.props.getAttendanceTypes ( this.props.token );
        this.props.setMainTitle('Cargando datos...', [] );

        
      }

 
      isAuth () {
        // if(this.props.user.user_type === 'TUTOR') {
            // if (this.props.course.tutors.find((tutor) => tutor.persona_id === this.props.user.persona_id)) {
            //   return true;
            // } else {
            //   return false;
            // }
        // } else {
           return true;
        // }
      }

      getRows(thisDate) {
        
        return this.props.course.students.map( (student) => {
 
          let obj =  { studentName: Utils.capitalize( student.last_name + ", " + student.name ) } 
          obj.persona_id = student.persona_id;
          obj.attendance = this.props.courseAttendance.filter( att => att.persona_id === student.persona_id );
          obj.width= "50px";
 
          return obj; 
        })

      }


      monthNavigator ( anio, currentMonth  ) {
       return (
          <table><tr>
            <td width='10%'>
             <Button style={{width:'100%'}} 
                disabled={currentMonth === 0 }
                onClick={() => { this.setState ( { currentDate: new Date(anio, currentMonth -1, 1 ) }) }}
                size="sm">{'<<'} </Button>
            </td>
            <td width='80%' align='center'>
              <p class="btn btn-secondary btn-sm"  style={{width:'100%', backgroundColor: '#66615B'}}>
                {Const.MONTHS[currentMonth]}
              </p>
            </td>
            <td width='10%'>
              <Button 
                  disabled={currentMonth === Math.min(11,this.state.mesActual) }
                  onClick={() => { this.setState ( { currentDate: new Date(anio, currentMonth + 1, 1 ) }) }}
                 size="sm">{'>>'}</Button> 
            </td></tr>
          </table>
        )
      }

      getColumns ( thisDate ) {
        // Loop en el mes actual
        const mes = thisDate.getMonth();
        const primero = (new Date(thisDate.getFullYear(), mes, 1)).getDay() ;

        let columns = [] ;
        for (let i = 1; i <= Const.MONTHS_DAYS[mes]; i++) {
          
          let wd = ((primero+i-1) % 7) ;

          if (wd>0 && wd <6) {
          columns.push(
                  { 
                      width: "50px" , 
                      wd: wd,
                      day:  Const.WEEK_DAYS_SHORT[wd],
                      title: i, 
                      field: i
                  } 
              )
            }
        }
       
        columns.unshift({ width: '300px', title: this.monthNavigator( thisDate.getFullYear(), mes ) , field: 'studentName' });
        
        return columns ;
      }
  

      renderCell = ( row, col, anio, mesF, mes, current  ) => {
        let dt =  anio + "-" + mesF + "-" + ("0"+(col.field)).slice(-2) ;
        let tot = 0 ;
        let faltas = row.attendance.filter( obj => obj.date === dt );
        faltas.map( tmp => { tot = tot + parseFloat(tmp.qty); return null; }) ;
        
        return (
          ( faltas.length === 0) ?
            <>
              <td  bgcolor={current?"#ffdddd":""} className="td-selected" align="center" style={{cursor: 'pointer'}}
                      onClick={() => { this.setAttendance({studentName: row.studentName, persona_id: row.persona_id}, faltas, new Date(anio, mes,col.field) )}}
                 >.</td>
              {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
           </>
            : 
              faltas.length === 1 ?
                 <>  
                  <td  bgcolor={current?"#ffdddd":""} className="td-selected" align="center"
                      style={{cursor: 'pointer',
                              color: faltas[0].justification!=="Y"&&faltas[0].justification_required==="Y"?"red":"" }}
                      onClick={() => { this.setAttendance({studentName: row.studentName, persona_id: row.persona_id}, faltas, new Date(anio, mes,col.field) )}}
                  >
                    {faltas[0].attendance_type}
                  </td>
                  {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                 </>
                 :
                 <>
                  <td bgcolor={current?"#ffdddd":""} className="td-selected" align="center" 
                      style={{cursor: 'pointer'}}
                      onClick={() => { this.setAttendance({studentName: row.studentName, persona_id: row.persona_id}, faltas, new Date(anio, mes,col.field) )}}
                  >
                  Ver +
                 </td>
                 {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                </>
           )
      }

      renderEmpty = (col, bgcolor) => {
         return (
            <>
              <td  bgcolor={bgcolor} align="center"></td>
              {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
           </>
           )
      }

      closeMe = () => {
        this.setModalOpen(false)
      }
      

      renderStatus = ( mes, dia ) => {
        let diaStr = this.state.anioActual + '-' + ('0'+ (mes+1)).slice(-2) + '-' +  ('0'+ dia).slice(-2); 

        let st = this.props.courseAttendanceStatus.filter( att =>att.status_date === diaStr) ;
            return(
              
                  (st.length > 0 && st[0].status==='Y'?
                    <Button 
                        color="info" 
                        size="sm"
                        onClick={() => { let data = { date: diaStr, status: 'P' };
                                    this.props.postCourseAttendanceStatus( this.props.token, this.props.course.course_id, data )}}
                    >✓</Button>
                          
                  :
                          <Button 
                            color="warning" 
                            size="sm"
                            onClick={() => { let data = { date: diaStr, status: 'Y' };
                                            this.props.postCourseAttendanceStatus( this.props.token, this.props.course.course_id, data )}}
                            >P</Button>
                  )
        )
      }

    setCargaDirecta = ( val ) => {
      this.setState({ cargaDirecta: val }) ;
      if (val) {
        this.setState({ selectedAttendance : Const.getObjectByValue( this.props.attendanceTypes, 'AU') }) ;
      }
    }

    setSelectedAttendance = ( val ) => {
      this.setState({ selectedAttendance: val , justified: 'N'}) ;
    }
    
    setJustified = ( val ) => {
      this.setState({ justified: val.value}) ;
    }

    isHoliday = ( anio, mes, dia ) => {
      let is = this.props.holidays.filter( h => h.holiday_dt === ''.concat(anio,'-',('0'.concat(mes)).slice(-2),'-',('0'.concat(dia)).slice(-2)) );
      return is.length > 0 ? is[0].description : undefined
    }

    setAttendance = async ( student, faltas, fecha ) => {
      this.studentAttendanceBrief ( student.persona_id );

      if (!this.state.cargaDirecta) {
        this.setState({currentAttendance: [...faltas], currentDate: fecha, currentStudent: student })
        this.setModalOpen(!this.state.modalOpen) ;
      } else {
        console.log(this.props.currentCalendarID)
          this.props.postAttendance ( this.props.token, student.persona_id, this.props.currentCalendarID, 
            { "date": sdf.asString('yyyy-MM-dd', fecha),
            "attendance_type":this.state.selectedAttendance.value, 
            "description": this.state.selectedAttendance.description,
            "qty":this.state.selectedAttendance.qty,
            "justified": (this.state.selectedAttendance.justification!=='Y'?'': this.state.justified),
            "justification_required": this.state.selectedAttendance.justification
          }
        );
      }
    }

    studentAttendanceBrief = ( studentID ) => {
      let dev = { total:0 , not_justified: 0, justified: 0};
      this.props.courseAttendance.filter( att => att.persona_id === studentID).map( itm => {
        dev.total = dev.total + parseFloat(itm.qty) ;
        if (itm.justification_required === 'Y' && itm.justification !== 'Y' ) dev.not_justified =  dev.not_justified + parseFloat(itm.qty) ;
      })
      dev.justified = dev.total - dev.not_justified ;
      return dev;
    }


     render() {
      
      let fecha = this.state.currentDate ;  
      const mes = fecha.getMonth();
      const mesF = ('0' + (fecha.getMonth()+1)).slice(-2);
      const anio = fecha.getFullYear();
      const esteMes = ( fecha.getMonth() === (new Date()).getMonth()) ;
      const esteDia = (new Date()).getDate() ;
 
      
      return (
          <>
          
          <Modal toggle={() => this.setModalOpen(!this.state.modalOpen)} isOpen={this.state.modalOpen}  size="lg" >
             <ModalBody >
                <DayAttendanceCard 
                  student={this.state.currentStudent}
                  attendance={this.state.currentAttendance}
                  fecha={this.state.currentDate}
                  deleteAtt={this.props.deleteAttendance}
                  addAtt={this.props.postAttendance}
                  calendarID={this.props.currentCalendarID}
                  token={this.props.token}
                  close={this.closeMe}
                />
            </ModalBody>
          </Modal>

          {( this.props.course.course_id ) 
                &&!this.props.view.loadingModules.getSchoolCourse ?
             <>
              {this.isAuth()?
                <div className="content"> 
                                 <Card>
                    <CardBody>
                       <Row>
                          <Col sm="5"> 
                               <input type="checkbox" 
                                style={{ marginRight: "5px"}}
                                value={this.state.cargaDirecta} 
                                onClick={() => this.setCargaDirecta(!this.state.cargaDirecta) }
                              />
                               Usar carga directa 
                              <br />
                            <Label>Seleccione esta opción y el la lista de la derecha cual es el tipo de inasistencia a cargar. Luego
                            con solo clickear en la lista se cargará. En caso que se quieran modificar se deberá
                            desmarcar hacerlo manualmente.</Label>
                          </Col>
                          <Col sm="5"> 
                            <FormGroup> 
                              <Label>Tipo de inasistencia</Label>
                              <Select
                                  name="current"
                                  isDisabled={!this.state.cargaDirecta}
                                  value= { this.state.selectedAttendance }
                                  // defaultValue= { this.props.attendanceTypes[0]}
                                  onChange={(sel) => this.setSelectedAttendance(sel)}
                                  options={this.props.attendanceTypes}
                                  placeholder="Seleccione tipo de inasistencia"
                                />
                            </FormGroup>
                          </Col>
                          <Col sm="2"> 
                              <FormGroup> 
                                <Label>Justificada</Label>
                                <Select
                                    isDisabled={!this.state.cargaDirecta ||
                                      this.state.selectedAttendance&& this.state.selectedAttendance.justification!=='Y' }
                                    value= { Const.getObjectByValue(Const.YES_NO, this.state.justified)}
                                    onChange={(sel) => this.setJustified(sel)}
                                    options={Const.YES_NO}
                                    placeholder="Seleccione"
                                  />
                              </FormGroup>
                          </Col>
                         
                        </Row>
                    </CardBody>
                  </Card>
                 
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <div class="table-wrapper">
                            <table>
                             <tr className='fixed-th '>
                                { this.getColumns(fecha).map((col, idx) => {
                                  let holiday = this.isHoliday (anio, mes + 1, col.field );
                                  return(
                                  (idx===0 ?
                                    ( this.props.view.loadingModules.getCourseAttendance ||
                                      this.props.view.loadingModules.postAttendance ||
                                      this.props.view.loadingModules.deleteAttendance ) ?
                                      <td width={col.width}>Cargando asistencias <Spinner /></td>
                                      :
                                      <td width={col.width}></td>
                                  :
                                  <>
                                  {holiday?
                                    <>
                                      <td width={col.width} align="center" bgcolor= "#d9d9d9"><div title={holiday}>{col.day}</div></td>
                                      {col.wd===5 && <td width="4" bgcolor="#c0c0c0"></td>}
                                    </>
                                    :
                                    <>
                                      <td width={col.width} align="center" 
                                          bgcolor={esteMes&&col.field===esteDia?"#ffdddd":""}
                                          >{col.day}</td>
                                      {col.wd===5 && <td width="4" bgcolor="#c0c0c0"></td>}
                                    </>
                                  }
                                  </>
                                  )
                                  )
                                }) }
                                 <td style={{borderLeft:'1px solid'}} colSpan={2} align="center">Acumulado</td>
                              </tr>
                              <tr className='fixed-th2 '>
                                { this.getColumns(fecha).map((col) => {
                                  let holiday = this.isHoliday (anio, mes + 1, col.field );

                                  return(
                                    holiday?
                                      <>
                                        <td align="center" bgcolor= "#d9d9d9"><div title={holiday}>{col.title}</div></td>
                                        {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                                      </>
                                    :
                                    <>
                                      <td  align="center" 
                                      bgcolor={holiday || ( esteMes&&col.field===esteDia)?"#ffdddd":""}>{col.title}</td>
                                      {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                                    </>
                                    )
                                }) }
                                 <td style={{borderLeft:'1px solid'}} align="center">No Just</td>
                                 <td  align="center">Tot</td>
                              </tr>
                              
                              { this.getRows(fecha).map((row,idx) => {
                                let acumulado = this.studentAttendanceBrief(row.persona_id);

                                return(
                                  <>
                                    <tr className="tr-selected" bgcolor={idx%2===0?"#f0f0f0":""}>
                                      { this.getColumns(fecha).map((col) => {
                                        let holiday = this.isHoliday (anio, mes + 1, col.field );
                                        return(
                                          <>
                                            {(col.field==='studentName')?
                                                  <td>{row.studentName}</td>
                                          
                                            :
                                            holiday?
                                              this.renderEmpty(col,"#d9d9d9")
                                            :
                                            ( (mes < this.state.mesActual || 
                                                (mes === this.state.mesActual && col.field <= this.state.diaActual) )
                                              ?
                                              this.renderCell ( row, col, anio, mesF, mes, esteMes&&col.field===esteDia  )
                                              :
                                              this.renderEmpty(col)
                                            )
      
                                          }
                                          
                                        </>)
                                      }) }
                                      <td style={{borderLeft:'1px solid'}} align="center">{acumulado.not_justified>0?acumulado.not_justified:'-'}</td>
                                      <td align="center">{acumulado.total>0?acumulado.total:'-'}</td>
                                      
                                    </tr>
                                    </>
                                )

                              })}

                              <tr className='fixed-foot '>
                                {
                                  this.getColumns(fecha).map((col,idx) => {
                                    let holiday = this.isHoliday (anio, mes + 1, col.field );
                                    return(
                                      <>
                                        {(col.field==='studentName')?
                                              <td align='right'>Asistencias validadas</td>
                                      
                                        :
                                        holiday?
                                        <>
                                        <td align="center">
                                           <Button 
                                                color="secondary" 
                                                size="sm"
                                            >F</Button>
                                        </td>
                                        {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                                        </>
                                          :
                                            ( (mes < this.state.mesActual || 
                                                    (mes === this.state.mesActual && col.field <= this.state.diaActual) )
                                                ?
                                                <>
                                                  <td align="center">{this.renderStatus( mes, col.field )}</td>
                                                      {col.wd===5 && <td bgcolor="#c0c0c0"></td>}
                                                  </>
                                                  :
                                                  this.renderEmpty(col)

                                            )

                                      }

                                    </>)
                                  })
                                }
                              </tr>

                            </table>
                          </div>
                        </Col>
                      </Row>
                    
                    </CardBody>
                  </Card>
                    <ul className='holidays'>
                      {
                        this.props.holidays.filter( 
                            h => (h.holiday_dt).substr(0,7) === ''.concat(anio,'-',('0'.concat(mes+1)).slice(-2)) ).map ( f => {
                              return <li>{parseInt(f.holiday_dt.substr(8,2))} - {f.description} </li>
                            })
                      }
                      </ul>
                  <ul className='footer-info '>
                    <li>El punto (.) que aparece automáticamente significa que esta presente</li>
                    <li>Luego de cargar las inasistencias se debe confirmar presionando el 
                      botón <Button color="warning" size="sm">P</Button> correspondiente al día.</li>
                    <li>Para deshacer la confirmación, debe presior el 
                      botón <Button color="info" size="sm">✓</Button> correspondiente al día.</li>
                    <li>Se pueden modificar días anteriores</li>
                  </ul>
                  
                  </div>
              :
                <CenterMessageCard 
                    icon="fa-info"
                    title="Autorización requerida">
                      No tenés permisos para acceder a este curso. En caso que lo requieras solicita al administrador que 
                      te agregue como tutor
                      de <b>{'Curso ' + this.props.course.name + " - Turno: " + this.props.course.shift_name }</b>
                </CenterMessageCard>  
               }
              </>
              :
              <LoadingPage 
                title="Cargando curso"/>
              } 
           </> 
            
          );
    }
  }


  const mapStateToProps = state => {
    return {
        course: state.courses.course,
        holidays: state.courses.holidays,
        courseAttendance: state.courses.courseAttendance,
        courseAttendanceStatus: state.courses.courseAttendanceStatus,
        attendanceTypes: state.courses.attendanceTypes,
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user
    }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getSchoolCourse: (token, courseID, calendarID) => {
          dispatch(courseActions.getSchoolCourse(token, courseID, calendarID));
        } ,
        setMainTitle: ( title, menu ) => {
          dispatch( viewActions.setMainTitle(title, menu)) ;
        },
        getHolidays: ( token, calendarID ) => {
          dispatch( attendanceActions.getHolidays( token, calendarID ))
        },

        getCourseAttendance: ( token, courseID, calendarID ) => {
          dispatch( attendanceActions.getCourseAttendance( token, courseID, calendarID ))
        },
        getCourseAttendanceStatus: ( token, courseID ) => {
          dispatch( attendanceActions.getCourseAttendanceStatus( token, courseID ))
        },
        postCourseAttendanceStatus: ( token, courseID, data ) => {
          dispatch( attendanceActions.postCourseAttendanceStatus( token, courseID, data ))
        },
        deleteAttendance: ( token, studentID, attendanceID ) => {
          dispatch( attendanceActions.deleteAttendance( token, studentID, attendanceID ))
        },
        postAttendance: ( token, studentID, calendarID, data ) => {
          dispatch( attendanceActions.postAttendance( token, studentID, calendarID, data ))
        },
        getAttendanceTypes: ( token ) => {
          dispatch( attendanceActions.getAttendanceTypes( token ))
        }

     }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(CourseAttendance);

